import { FC } from 'react'
import { Box, Typography } from '@mui/material'
import Grid from '@mui/material/Grid'
import { useI18n } from '@popety_io/popety-io-lib'

interface IProp {
  type?: string
  data: any
}

const CurrentSolaireInstalationSection: FC<IProp> = ({ data }) => {
  const { t } = useI18n()

  const totalPower =
    data?.totalPower ||
    (data?.instalationDate
      ?.map((d: any) => d?.power)
      ?.reduce((a: any, b: any) => a + b, 0) ??
      data.solar_installed_power)

  return (
    <div>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          marginBlock: '16px',
        }}
      >
        <Typography
          variant="h6"
          sx={{
            marginBottom: '4px',
            fontSize: '1.1rem',
            textTransform: 'uppercase',
          }}
        >
          {t('common.Installation solaire actuelle')}
        </Typography>
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={6}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: 'fit-content',
              maxWidth: '120px',
              textAlign: 'center',
            }}
          >
            <Typography variant="h6" fontWeight="600" fontSize="1.34rem">
              {totalPower ? `${totalPower} kW` : '-'}
            </Typography>
            <Typography>{t('estimate.Puissance totale')}</Typography>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <Box
            sx={{
              display: 'flex',
              gap: '10px',
            }}
          >
            <Typography
              fontWeight="500"
              sx={{
                color: '#969696',
              }}
            >
              {t('estimate.Date installation')}:{' '}
            </Typography>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              {data?.instalationDate?.length ? (
                data?.instalationDate?.map((item: any, index: number) => (
                  <Box
                    key={index}
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      gap: '5px',
                    }}
                  >
                    <Typography fontWeight="500" key={index}>
                      {item.date || ''}
                    </Typography>

                    <Typography fontWeight="500" key={index}>
                      {item.kw ? `(${item.kw} kW)` : '-'}
                    </Typography>
                  </Box>
                ))
              ) : (
                <span>-</span>
              )}
            </Box>
          </Box>
        </Grid>
      </Grid>
    </div>
  )
}

export default CurrentSolaireInstalationSection
